import $ from 'jquery';
import { setupEsLocationSelects } from '../components/forms/es-location-helper';

function setupForm() {
    var $form = $('.dealer-form');
    var $selectCity = $form.find('select[name="city_id"]');
    var $contentDealers = $('.content-dealers');

    function fetchDealers() {
        if (!$selectCity.val()) {
            $contentDealers.empty();
            return;
        }

        $.ajax({
            type: 'GET',
            url: $form.data('action'),
            data: $form.serialize(),
            success: function (data) {
                $contentDealers.html(data.html);
            },
            error: function (data) {
                console.error(data);
            },
        });
    }

    setupEsLocationSelects($form, {
        hideUntilSelected: false,
        onProvinceChange: function () {
            $contentDealers.empty();
        },
        onDepartmentChange: function () {
            $contentDealers.empty();
        },
        onCityChange: fetchDealers,
    });
}

function initialize() {
    setupForm();
}

initialize();
